/* src/app/loader/loader.component.scss */
.progressLoader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  z-index: 100000;
  overflow: hidden;
  pointer-events: none;
  background: rgba(229, 234, 242, 0.65);
}
.progressLoader .paginate-loader {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.progressLoader .paginate-loader::before,
.progressLoader .paginate-loader::after {
  content: "";
  position: absolute;
  top: 0;
  height: 100%;
  border-radius: 0 4px 4px 0;
  will-change: left, opacity;
}
.progressLoader .paginate-loader::before {
  left: -35%;
  width: 35%;
  background:
    linear-gradient(
      90deg,
      transparent 0%,
      rgba(37, 59, 128, 0.75) 25%,
      #253b80 65%,
      #6c8ce5 100%);
  box-shadow: 0 0 8px rgba(37, 59, 128, 0.35);
  animation: progress-loader 1.5s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}
.progressLoader .paginate-loader::after {
  left: -25%;
  width: 25%;
  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(56, 103, 214, 0.45),
      transparent);
  animation: progress-loader-secondary 1.5s ease-in-out infinite;
  animation-delay: 0.18s;
}
@keyframes progress-loader {
  0% {
    left: -35%;
    opacity: 0;
  }
  12% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
}
@keyframes progress-loader-secondary {
  0% {
    left: -25%;
    opacity: 0;
  }
  15% {
    opacity: 0.65;
  }
  80% {
    opacity: 0.4;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
}
@media (max-width: 768px) {
  .progressLoader {
    height: 3px;
  }
  .progressLoader .paginate-loader::before {
    width: 42%;
  }
  .progressLoader .paginate-loader::after {
    width: 28%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .progressLoader .paginate-loader::before,
  .progressLoader .paginate-loader::after {
    animation: none;
  }
  .progressLoader .paginate-loader::before {
    left: 0;
    width: 100%;
    opacity: 0.75;
    background: #253b80;
    box-shadow: none;
  }
  .progressLoader .paginate-loader::after {
    display: none;
  }
}
/*# sourceMappingURL=loader.component.css.map */
